// extracted by mini-css-extract-plugin
module.exports = {"AwardsItem":"AwardsItem_AwardsItem__3HnIM"};